export const copiarTexto = async (texto) => {
  const valor = (texto ?? "").toString();
  if (!valor) return false;
  try { await navigator.clipboard.writeText(valor); return true; }
  catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = valor; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta); return ok;
    } catch { return false; }
  }
};
export const leerTextoPortapapeles = async () => {
  try { return await navigator.clipboard.readText(); }
  catch { return null; }
};
